import { useKindeAuth } from '@kinde-oss/kinde-auth-react';

import { Button, Stack, Typography } from '@mui/material';

// designs.dev login screen — this is an internal playground, not the member
// app, so it gets its own identity rather than llama's SignInV2.
function Welcome() {
  const { login } = useKindeAuth();

  // Carry the deep link the visitor first hit (stashed by App while signed out)
  // through the OAuth flow as login state, so it survives the login round-trip
  // even if browser storage doesn't. Kinde hands it back in onSuccess.
  const handleSignIn = () => {
    const returnTo = sessionStorage.getItem('returnTo');
    login(returnTo ? { state: { returnTo } } : undefined);
  };

  return (
    <Stack
      sx={{
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
      spacing={3}
    >
      <Typography variant='h2'>Loft</Typography>
      <Button variant='contained' onClick={handleSignIn}>
        Sign in
      </Button>
    </Stack>
  );
}

export default Welcome;
